<template>
  <section-collapseable
    title="Lead Details"
    editable
    second-button-text="Open Call Script"
    :hide-second-button="selectedCallScriptId === null"
    @edit="$refs.leadDetailsModal.open(record)"
    @secondButtonClick="$refs.leadCallScriptFormModal.open(selectedCallScriptId)"
  >
    <p class="detail_item"><span class="text-uppercase">Campaign</span> {{ campaign ? campaign.label : 'No Campaign' }}</p>
    <p class="detail_item"><span class="text-uppercase">Motivation</span> {{ motivation }}</p>
    <p class="detail_item"><span class="text-uppercase">Exit Strategy</span> {{ exitStrategy }}</p>
    <p class="detail_item"><span class="text-uppercase">Temperature</span> {{ temperature }}</p>
    <p class="detail_item"><span class="text-uppercase">Call Script</span>
      <form-field-select
        v-model="selectedCallScript"
      >
        <option :value="null">No Call Script</option>
        <option
          v-for="callScript in activeCallScripts"
          :key="callScript.id"
          :value="callScript.id"
        >{{ callScript.name }}</option>
      </form-field-select>
    </p>

    <modal-container>
      <modal-crud-form
          ref="leadDetailsModal"
          title="Lead Details"
          form-component="lead-details-form"
          :hideDeleteButton="true"
      ></modal-crud-form>
    </modal-container>

    <lead-call-script-form
      ref="leadCallScriptFormModal"
    ></lead-call-script-form>
  </section-collapseable>
</template>

<script>
import {MODELS} from "../../../services/models";
import {ENUMS} from '../../../services/enums'
import LeadCallScriptForm from "../../../forms/LeadCallScriptForm";

export default {
  name: "LeadDetails",
  components: {LeadCallScriptForm},
  data() {
    return {
      selectedCallScriptId: null,
    }
  },
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        motivation: null,
        exit_strategy: null,
        temperature: null,
      };
    },
    campaign() {
      return this.$store.state.market.campaigns.find(campaign => campaign.id === this.record.campaign_id);
    },
    motivation() {
      return this.$utils.newGetEnumLabel(this.record.motivation, ENUMS.MotivationEnum);
    },
    exitStrategy() {
      return this.$utils.newGetEnumLabel(this.record.exit_strategy, ENUMS.ExitStrategyEnum);
    },
    temperature() {
      return this.$utils.newGetEnumLabel(this.record.temperature, ENUMS.TemperatureEnum);
    },
    activeCallScripts() {
      return this.$store.getters.callScripts.filter(cs => cs.status === ENUMS.CallScriptStatusEnum.Active.value);
    },
    selectedCallScript: {
      get() {
        if (this.record.createdBy.class_name === MODELS.CallScript.class_name) {
          const sourceCallScript = this.activeCallScripts.find(cs => cs.id === this.record.createdBy.id);
          if (sourceCallScript) {
            this.selectedCallScriptId = sourceCallScript.id
            return sourceCallScript.id
          };
        }

        const defaultCallScripts = this.activeCallScripts.find(cs => cs.is_default);
        if (defaultCallScripts) {
          this.selectedCallScriptId = defaultCallScripts.id
          return defaultCallScripts.id
        }

        this.selectedCallScriptId = null;
        return null;
      },
      set(value) {
        this.selectedCallScriptId = value;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.detail_item {
  margin-top: 8px;
  margin-bottom: 12px;

  span {
    display: inline-block;
    min-width: 100px;
    font-size: 0.625rem;
    color: $text-muted;
  }

  .form_field {
    display: inline-block;
    width: 60%;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
